module.exports = {"360823100":"水边镇","360823101":"马埠镇","360823102":"巴邱镇","360823103":"仁和镇","360823104":"砚溪镇","360823105":"罗田镇","360823200":"桐林乡","360823201":"福民乡","360823202":"戈坪乡","360823203":"金江乡","360823204":"金坪民族乡","360823400":"峡江县工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360823.json
// module id = 1422
// module chunks = 0